<template>
  <div class="dashboard-announcement-block">
    <Tabs class="" v-model="curTab" :animated="false" style="height:100%">
      <TabPane label="最新公告" name="announcement">
        <Table ref="dataTable"
          size="small"
          stripe
          disabledHover
          :height="tabContentHeight"
          :columns="announcementColumns"
          :data="announcementData">
        </Table>
      </TabPane>
      <TabPane label="公示信息" name="release">
        <Table ref="dataTable"
          size="small"
          stripe
          disabledHover
          :height="tabContentHeight"
          :columns="releaseColumns"
          :data="releaseData">
        </Table>
      </TabPane>
      <TabPane label="政策法规" name="regulation">
        <Table ref="dataTable"
          size="small"
          stripe
          disabledHover
          :height="tabContentHeight"
          :columns="regulationColumns"
          :data="regulationData">
        </Table>
      </TabPane>
      <Button size="small" slot="extra" @click="more">更多</Button>
    </Tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curTab: 'announcement',
      tabContentHeight: null,
      announcementColumns: [
        {
          title: '类型',
          key: 'type',
          width: 70,
          render: (h, params) => {
            return h('span', null, this.$common.announcementType[params.row.type.toString()])
          }
        },
        {
          title: '标题',
          key: 'title',
          ellipsis: true,
          render: (h, params) => {
            return h('span', null, [
              h('router-link', {
                props: {
                  to: {
                    name: 'announcement-detail',
                    params: {
                      id: params.row.tid
                    }
                  }
                }
              }, params.row.title)
            ])
          }
        },
        {
          title: '发布时间',
          key: 'createTime',
          width: 120,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.createTime).format('YYYY-MM-DD'))
          }
        },
      ],
      announcementData: [],
      releaseColumns: [
        {
          title: '类型',
          key: 'type',
          width: 70,
          render: (h, params) => {
            return h('span', null, this.$common.announcementType[params.row.type.toString()])
          }
        },
        {
          title: '标题',
          key: 'title',
          ellipsis: true,
          render: (h, params) => {
            return h('span', null, [
              h('router-link', {
                props: {
                  to: {
                    name: 'announcement-detail',
                    params: {
                      id: params.row.tid
                    }
                  }
                }
              }, params.row.title)
            ])
          }
        },
        {
          title: '发布时间',
          key: 'createTime',
          width: 120,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.createTime).format('YYYY-MM-DD'))
          }
        },
      ],
      releaseData: [],
      regulationColumns: [
        {
          title: '类型',
          key: 'type',
          width: 70,
          render: (h, params) => {
            return h('span', null, this.$common.announcementType[params.row.type.toString()])
          }
        },
        {
          title: '标题',
          key: 'title',
          ellipsis: true,
          render: (h, params) => {
            return h('span', null, [
              h('router-link', {
                props: {
                  to: {
                    name: 'announcement-detail',
                    params: {
                      id: params.row.tid
                    }
                  }
                }
              }, params.row.title)
            ])
          }
        },
        {
          title: '发布时间',
          key: 'createTime',
          width: 120,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.createTime).format('YYYY-MM-DD'))
          }
        },
      ],
      regulationData: [],
    }
  },
  watch: {
    '$store.getters.screenHeight': function () {
      this.calcTabContentHeight()
    },
    '$store.getters.screenWidth': function () {
      this.calcTabContentHeight()
    }
  },
  async mounted () {
    this.announcementData = await this.initData({
      type: 0,
      types: [0]
    })
    this.releaseData = await this.initData({
      type: 1,
      types: [1]
    })
    this.regulationData = await this.initData({
      type: 2,
      types: [2]
    })
    this.calcTabContentHeight()
  },
  methods: {
    calcTabContentHeight () {
      if (!document.querySelector('.dashboard-announcement-block')) {
        return false
      }
      let blockHeight = document.querySelector('.dashboard-announcement-block').clientHeight
      this.tabContentHeight = blockHeight - 36 - 16 // 减去ivu-tab-bar高度和margin
      // console.log(blockHeight, this.tabContentHeight)
    },
    initData (query) {
      return new Promise((resolve, reject) => {
        this.$Api.Announcement.list(query, 1, 8).catch(err => {
          this.$Message.error(err.message)
          reject(err)
        }).then(res => {
          resolve(res.data)
        })
      })
    },
    more () {
      switch (this.curTab) {
        case 'announcement':
          this.$router.push({name: 'announcement-list', params: {types: [0]}})
          break
        case 'release':
          this.$router.push({name: 'announcement-list', params: {types: [1]}})
          break
        case 'regulation':
          this.$router.push({name: 'announcement-list', params: {types: [2]}})
          break
        default:
          this.$router.push({name: 'announcement-list', params: {types: [0]}})
          break
      }
    }
  }
}
</script>

<style lang="less">
.dashboard-announcement-block {
  position: relative;
  height: 100%;
  .ivu-table {
    &::before {
      display: none
    }
  }
}
</style>